import React from 'react';
import Image from 'next/image';

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from '@/src/components/ui/carousel';
import { IResolvedSteppers } from '@/src/utils/collections/steppers.mapper';
import { StepperScrollableItem } from '@/src/components/steppers/StepperScrollable/StepperScrollableItem';

export const StepperScrollable = ({
  title,
  subtitle,
  items,
  showStepperLine,
}: IResolvedSteppers) => {
  return (
    <div className="relative w-full">
      <Image
        src={'/static/icons/title-decoration-pink.svg'}
        alt="background-shape"
        width={450}
        height={300}
        className="decoration-visible absolute right-0 top-0 -z-10 hidden w-[300px] rotate-[-25deg] -scale-x-100 opacity-10 lg:w-[450px] xl:top-[-100px] xl:w-[600px] 2xl:w-[700px]"
      />
      <div className={`mx-auto max-w-1200 py-18 md:px-4`}>
        <div className={`mb-10 space-y-2.5 text-center`}>
          <div className={'text-4xl font-semibold lg:text-6xl'}>{title}</div>
          <div className={'mx-auto max-w-xl leading-[22.5px]  text-gray'}>
            {subtitle}
          </div>
        </div>
        <div className={'hidden flex-row justify-between md:flex'}>
          {items.map((step, index) => (
            <StepperScrollableItem
              showStepperLine={showStepperLine}
              key={`stepper-scrollable-${index}`}
              title={step.title}
              id={index + 1}
              description={step.description}
              media={step.media}
              isIcon={step.isIcon}
            />
          ))}
        </div>
        <Carousel
          opts={{
            align: 'center',
          }}
          className="w-full md:hidden"
        >
          <CarouselContent>
            {items.map((step, index) => (
              <CarouselItem
                key={step.title + 'carousel' + index}
                className={'basis-10/12 items-center pl-0'}
              >
                <StepperScrollableItem
                  showStepperLine={showStepperLine}
                  key={`stepper-scrollable-carousel-${index}`}
                  title={step.title}
                  id={index + 1}
                  description={step.description}
                  media={step.media}
                  isIcon={step.isIcon}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselDots className={'mt-4'} />
        </Carousel>
      </div>
    </div>
  );
};
